import { j as t } from "./jsx-runtime-3tyXYecC.mjs";
import { c as g } from "./index-DkZ16bcJ.mjs";
import { l as X } from "./lodash-5ofSKtz3.mjs";
import * as N from "react";
import n, { forwardRef as me, useRef as ue, useImperativeHandle as pe, useMemo as xe } from "react";
import { f as o } from "./index-LyFokDcn.mjs";
import { F as fe } from "./form-note-CbSVsgBQ.mjs";
import { I as R } from "./icon-v2-DGtVEk7e.mjs";
import { L as ge } from "./layout-box-DFBM-kSI.mjs";
import { S as he } from "./status-message-BMoS1d1Y.mjs";
import { b as J } from "./inline-message-BYLpwrsI.mjs";
import { c as L, b as K, m as be } from "./tss-DN0acMKN.mjs";
import { M as O, d as Z } from "./constants-CnFYFetN.mjs";
import { _ as Ce } from "./composeRefs-YONvD-rx.mjs";
import { S as ye, F as we } from "./FormControlLabel-BtrCkdi3.mjs";
import { g as ke } from "./get-aria-describedby-G1wcWKF2.mjs";
import { g as ve, c as Fe } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { c as V } from "./createSvgIcon-ButWPptu.mjs";
import { s as $e, b as Ie, u as Se, c as Me } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { g as je } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { m as Re } from "./memoTheme-BzXKG_-k.mjs";
import { c as Q } from "./createSimplePaletteValueFilter-B7--0ryQ.mjs";
import { T as Le } from "./Typography-DfkimCSn.mjs";
const Ee = V(/* @__PURE__ */ t.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), Be = V(/* @__PURE__ */ t.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), ze = V(/* @__PURE__ */ t.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function Ne(e) {
  return ve("MuiCheckbox", e);
}
const H = je("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), Oe = (e) => {
  const {
    classes: a,
    indeterminate: i,
    color: c,
    size: r
  } = e, d = {
    root: ["root", i && "indeterminate", `color${L(c)}`, `size${L(r)}`]
  }, p = Me(d, Ne, a);
  return {
    ...a,
    // forward the disabled and checked classes to the SwitchBase
    ...p
  };
}, Ze = $e(ye, {
  shouldForwardProp: (e) => Ie(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, a) => {
    const {
      ownerState: i
    } = e;
    return [a.root, i.indeterminate && a.indeterminate, a[`size${L(i.size)}`], i.color !== "default" && a[`color${L(i.color)}`]];
  }
})(Re(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : K(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(Q()).map(([a]) => ({
    props: {
      color: a,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[a].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : K(e.palette[a].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(Q()).map(([a]) => ({
    props: {
      color: a
    },
    style: {
      [`&.${H.checked}, &.${H.indeterminate}`]: {
        color: (e.vars || e).palette[a].main
      },
      [`&.${H.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), He = /* @__PURE__ */ t.jsx(Be, {}), _e = /* @__PURE__ */ t.jsx(Ee, {}), Te = /* @__PURE__ */ t.jsx(ze, {}), Pe = /* @__PURE__ */ N.forwardRef(function(a, i) {
  const c = Se({
    props: a,
    name: "MuiCheckbox"
  }), {
    checkedIcon: r = He,
    color: d = "primary",
    icon: p = _e,
    indeterminate: u = !1,
    indeterminateIcon: y = Te,
    inputProps: F,
    size: b = "medium",
    disableRipple: x = !1,
    className: l,
    ...s
  } = c, w = u ? y : p, h = u ? y : r, $ = {
    ...c,
    disableRipple: x,
    color: d,
    indeterminate: u,
    size: b
  }, I = Oe($);
  return /* @__PURE__ */ t.jsx(Ze, {
    type: "checkbox",
    inputProps: {
      "data-indeterminate": u,
      ...F
    },
    icon: /* @__PURE__ */ N.cloneElement(w, {
      fontSize: w.props.fontSize ?? b
    }),
    checkedIcon: /* @__PURE__ */ N.cloneElement(h, {
      fontSize: h.props.fontSize ?? b
    }),
    ownerState: $,
    ref: i,
    className: Fe(I.root, l),
    disableRipple: x,
    ...s,
    classes: I
  });
}), Y = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 14", width: "14", height: "14" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement(
      "g",
      null,
      n.createElement("path", { d: "M1291.73781,625.59671 C1292.2153,624.82892 1292.02244,623.79241 1291.30698,623.28167 C1290.5884,622.76758 1289.62563,622.97789 1289.14969,623.74401 L1283.79149,632.36992 L1280.41947,629.95807 C1279.7009,629.44398 1278.73657,629.65429 1278.26219,630.42041 C1277.7847,631.18819 1277.97756,632.2247 1278.69302,632.73545 L1284.65316,637 L1291.73781,625.59671 Z", transform: "translate(-1278 -623)" })
    )
  )
);
Y.displayName = "Check14x14";
const q = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 12 12", width: "12", height: "12" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement("path", { fillRule: "nonzero", d: "M6,0 C2.6865,0 0,2.6865 0,6 C0,9.315 2.6865,12 6,12 C9.3135,12 12,9.315 12,6 C12,2.6865 9.3135,0 6,0 Z M5.5,3 C5.5,2.724 5.724,2.5 6,2.5 L6,2.5 C6.276,2.5 6.5,2.7235 6.5,3 L6.5,6.5 C6.5,6.776 6.276,7 6,7 L5.9995,7 C5.7235,7 5.4995,6.7765 5.4995,6.5 L5.4995,3 L5.5,3 Z M6,9.5 C5.586,9.5 5.25,9.164 5.25,8.75 C5.25,8.336 5.586,8 6,8 C6.414,8 6.75,8.336 6.75,8.75 C6.75,9.164 6.414,9.5 6,9.5 Z" })
  )
);
q.displayName = "CircleExclamation12x12";
const T = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 14", width: "14", height: "14" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement("path", { fillRule: "nonzero", d: "M7,0 C3.13425,0 0,3.13425 0,7 C0,10.8675 3.13425,14 7,14 C10.86575,14 14,10.8675 14,7 C14,3.13425 10.86575,0 7,0 Z M6.41666667,3.5 C6.41666667,3.178 6.678,2.91666667 7,2.91666667 L7,2.91666667 C7.322,2.91666667 7.58333333,3.17741667 7.58333333,3.5 L7.58333333,7.58333333 C7.58333333,7.90533333 7.322,8.16666667 7,8.16666667 L6.99941667,8.16666667 C6.67741667,8.16666667 6.41608333,7.90591667 6.41608333,7.58333333 L6.41608333,3.5 L6.41666667,3.5 Z M7,11.0833333 C6.517,11.0833333 6.125,10.6913333 6.125,10.2083333 C6.125,9.72533333 6.517,9.33333333 7,9.33333333 C7.483,9.33333333 7.875,9.72533333 7.875,10.2083333 C7.875,10.6913333 7.483,11.0833333 7,11.0833333 Z" })
  )
);
T.displayName = "CircleExclamation14x14";
const ee = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 12 3", width: "12", height: "3" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement("rect", { width: 12, height: 3, x: 0, y: 0, rx: 1.5 })
  )
);
ee.displayName = "Minus12x3";
const re = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 12 11", width: "12", height: "11" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement("path", { d: "M11.7559867,8.49994142 C12.4535017,9.61405738 11.5724842,11 10.1669543,11 L1.83277186,11 C0.427741449,11 -0.453277717,9.61405738 0.243737437,8.49994142 L4.41082844,0.842064972 C5.11334364,-0.280688324 6.88638177,-0.280688324 7.58889698,0.842064972 L11.7559867,8.49994142 Z M5.999999,9.36359335 C7.00011063,9.36359335 7.00011063,9.36359335 7.00011063,8.68175937 C7.00011063,7.99992606 7.00011063,7.99992606 5.999999,7.99992606 C4.99986208,7.99992606 4.99986208,7.99992606 5.00013592,8.68175937 C5.00040976,9.36359335 4.99986208,9.36359335 5.999999,9.36359335 Z M6,3.21383655 C5,3.21383655 5,3.9651449 5,4.33333156 L5,6.99999813 C5,7.36818812 7,7.36818812 7,6.99999813 L7,4.33333156 C7,3.9651449 7,3.21383655 6,3.21383655 Z" })
  )
);
re.displayName = "TriangleExclamation12x11";
const P = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 12", width: "14", height: "12" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement("path", { d: "M13.7153181,8.99993 C14.5290856,10.3368692 13.5012319,12 11.861447,12 L2.13823388,12 C0.499031703,12 -0.528824016,10.3368692 0.28436035,8.99993 L5.14596663,1.010478 C5.96556772,-0.336826 8.03411226,-0.336826 8.85371335,1.010478 L13.7153181,8.99993 Z M6.99984043,10.3635972 C7.99999999,10.3635972 7.99999999,10.0908628 7.99999999,9.5453964 C7.99999999,8.99993 7.99999999,8.7271964 6.99984043,8.7271964 C5.99968086,8.7271964 5.99999999,8.99993 5.99999999,9.5453964 C5.99999999,10.0908628 5.99968086,10.3635972 6.99984043,10.3635972 Z M6.99984043,3 C5.99968086,3 6,3.558174 6,4 L6,7.199998 C6,7.641826 6,8 7,8 C8,8 8,7.641826 8,7.199998 L8,4 C8,3.558174 8,3 6.99984043,3 Z" })
  )
);
P.displayName = "TriangleExclamation14x12";
const W = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 18 16", width: "18", height: "16" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement("path", { d: "M17.633981,11.9999072 C18.6802535,13.7824928 17.3587273,16 15.2504323,16 L2.74915794,16 C0.64161221,16 -0.679916614,13.7824928 0.365606175,11.9999072 L6.61624302,1.34730406 C7.67001589,-0.449101352 10.3295732,-0.449101352 11.3833461,1.34730406 L17.633981,11.9999072 Z M8.99979512,13.8181302 C9.62080861,13.8181302 10,13.4544843 10,12.7271957 C10,11.9999072 10.0425138,11.6362624 8.99979512,11.6362624 C7.95707643,11.6362624 8,11.9999072 8,12.7271957 C8,13.4544843 8.3787805,13.8181302 8.99979512,13.8181302 Z M9,4.26666418 C8,4.26666418 8,4.7442322 8,5.33333089 L8,9.59999773 C8,10.1891018 8,10.6666644 9,10.6666644 C10,10.6666644 10,10.1891018 10,9.59999773 L10,5.33333089 C10,4.7442322 10,4.26666418 9,4.26666418 Z" })
  )
);
W.displayName = "TriangleExclamation18x16";
const G = {
  biggie: 24,
  large: 20,
  medium: 16,
  small: 14
}, We = {
  biggie: "large",
  large: "large",
  medium: "medium",
  small: "medium"
};
function Ge(e = "", a = "", i) {
  if (e) {
    const c = `${e}-checkbox`, r = a ? `-${a}` : "", d = `-${i}`;
    return `${c}${r}${d}`;
  }
}
function _(e) {
  return o.ifFeature("encore", e === "biggie" || e === "large" ? 12 : 8, e === "biggie" ? 10 : 8);
}
function v(e) {
  return G[e] || G.medium;
}
function Ve(e) {
  return v(e) / G.biggie;
}
function De(e, a) {
  if (e === "error")
    switch (a) {
      case "small":
        return /* @__PURE__ */ t.jsx(q, {});
      case "medium":
        return /* @__PURE__ */ t.jsx(T, {});
      case "large":
        return /* @__PURE__ */ t.jsx(J, {});
      case "biggie":
        return /* @__PURE__ */ t.jsx(J, {});
      default:
        return /* @__PURE__ */ t.jsx(T, {});
    }
  if (e === "warning")
    switch (a) {
      case "small":
        return /* @__PURE__ */ t.jsx(re, {});
      case "medium":
        return /* @__PURE__ */ t.jsx(P, {});
      case "large":
        return /* @__PURE__ */ t.jsx(W, {});
      case "biggie":
        return /* @__PURE__ */ t.jsx(W, {});
      default:
        return /* @__PURE__ */ t.jsx(P, {});
    }
}
function Ue(e) {
  if (e === "error")
    return /* @__PURE__ */ t.jsx(R, { name: "circle-exclamation-solid", size: 16 });
  if (e === "warning")
    return /* @__PURE__ */ t.jsx(R, { name: "triangle-exclamation-solid", size: 16 });
}
const j = "inset 0 2px 2px 0 rgba(0, 0, 0, 0.15)", Ae = be()((e, a, i) => {
  const { constructs: c, palette: r, mixins: d, typography: p, mode: u } = e, y = `inset 1px 1px 0px 1px ${d.alpha(r.gray[900], 0.05)}`, { checked: F, indeterminate: b, disabled: x, status: l, size: s } = a, w = () => u === O.Dye ? Z.main : x ? o.ifFeature("encore", c.text.neutral.weak, r.gray[500]) : l === "error" ? r.error.main : l === "warning" ? r.warning.main : o.ifFeature("encore", c.text.neutral.strong, r.gray[1e3]), h = () => u === O.Dye ? Z.main : l === "error" ? r.error.main : l === "warning" ? r.warning.main : r.primary.main, $ = () => {
    let k = r.primary.main;
    return l === "warning" && (k = r.warning.main), l === "error" && (k = r.error.main), `1px solid ${k}`;
  }, I = () => b ? x ? o.ifFeature("encore", r.primary.contrastText, r.gray[500]) : l === "error" ? o.ifFeature("encore", r.primary.contrastText, r.error.main) : l === "warning" ? o.ifFeature("encore", r.primary.contrastText, r.warning.main) : o.ifFeature("encore", r.primary.contrastText, r.primary.main) : r.primary.contrastText, S = () => x ? r.gray[500] : l === "error" ? r.error.main : l === "warning" ? r.warning.main : r.gray[1e3];
  return {
    asterisk: {
      color: x ? r.gray[600] : r.primary.main,
      marginLeft: 4
    },
    error: {
      color: e.palette.error.main
    },
    label: {
      alignItems: "center",
      display: "flex",
      marginLeft: _(s)
    },
    labelContainer: {
      display: "flex"
    },
    labelContent: {
      color: w(),
      fontSize: p.fabricFontSize(s),
      fontStyle: l === "pending" ? "italic" : "normal",
      fontWeight: F || b ? p.fontWeightSemibold : p.fontWeightRegular,
      lineHeight: p.fabricLineHeight(s)
    },
    labelRoot: {
      marginLeft: o.ifFeature("encore", 0),
      marginRight: o.ifFeature("encore", 0)
    },
    note: o.ifFeature(
      "encore",
      {
        marginLeft: v(s) + _(s)
      },
      {
        color: r.gray[700],
        fontSize: p.fabricFontSize("teenie"),
        lineHeight: p.fabricLineHeight("teenie"),
        marginLeft: v(s) + _(s)
      }
    ),
    root: {
      outline: u === O.Dye ? `1px solid ${Z.main}` : void 0,
      // MUI should use the base color we are using
      "& .MuiCheckbox-root": {
        alignSelf: o.ifFeature("encore", "start"),
        backgroundColor: o.ifFeature("encore", "unset"),
        color: "inherit",
        height: o.ifFeature("encore", "auto"),
        padding: o.ifFeature("encore", 0),
        position: o.ifFeature("encore", "relative"),
        top: o.ifFeature("encore", s === "small" || s === "medium" ? "3px" : "2px")
      },
      // MUI provides a default asterisk that we don't want to show
      "& .MuiFormControlLabel-asterisk": {
        display: "none"
      }
    },
    selectedBox: {
      alignItems: "center",
      backgroundColor: h(),
      border: $(),
      borderRadius: 4,
      boxShadow: "none",
      boxSizing: "border-box",
      display: "flex",
      height: v(s),
      justifyContent: "center",
      opacity: 0,
      position: "absolute",
      transform: "scale(0)",
      transition: "transform 200ms ease, opacity 200ms ease, border-radius 200ms ease",
      width: v(s),
      ".MuiCheckbox-root.Mui-checked &": {
        borderRadius: o.ifFeature("encore", 4, 2),
        boxShadow: o.ifFeature(
          "encore",
          `1px 1px 0px 0px ${d.alpha(c.surface.neutral.xxStrong, 0.06)}`,
          "0 1px 0 0 rgba(0, 0, 0, 0.05)"
        ),
        opacity: 1,
        transform: "scale(1)"
      },
      ".MuiCheckbox-root.MuiCheckbox-indeterminate &": {
        opacity: o.ifFeature("encore", 1, 0),
        transform: o.ifFeature("encore", "scale(1)", "scale(0)")
      },
      ".MuiCheckbox-root.Mui-disabled &": {
        backgroundColor: o.ifFeature("encore", r.gray[400], r.gray[500]),
        border: `1px solid ${o.ifFeature("encore", r.gray[400], r.gray[500])}`,
        boxShadow: "none"
      },
      ".MuiCheckbox-root.Mui-disabled.Mui-checked &": {
        boxShadow: o.ifFeature("encore", `1px 1px 0px 0px ${d.alpha(c.surface.neutral.xxStrong, 0.06)}`)
      },
      [`.${i.root}:focus-within &`]: {
        boxShadow: o.ifFeature("encore", `0px 0px 0px 3px ${c.surface.primary.weak}`)
      },
      [`.${i.warning}:focus-within &`]: {
        boxShadow: o.ifFeature("encore", `0px 0px 0px 3px ${c.surface.warning.weak}`)
      },
      [`.${i.error}:focus-within &`]: {
        boxShadow: o.ifFeature("encore", `0px 0px 0px 3px ${c.surface.error.weak}`)
      }
    },
    selectedIcon: {
      display: "flex",
      fill: I(),
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.1))",
      position: "absolute",
      transform: F || b ? `scale(${Ve(s)})` : "scale(0)",
      transition: "transform 100ms ease 100ms"
    },
    statusIcon: {
      alignSelf: "start",
      display: "flex",
      fill: S(),
      marginRight: o.ifFeature("encore", 8, 6),
      position: "relative",
      top: o.ifFeature("encore", s === "small" || s === "medium" ? "3px" : "2px")
      // Copies the top spacing from the root styles
    },
    unselectedBox: {
      alignItems: "center",
      backgroundColor: o.ifFeature("encore", r.gray[100], r.common.white),
      border: `1px solid ${o.ifFeature("encore", r.gray[400], r.gray[500])}`,
      borderRadius: o.ifFeature("encore", 4, 2),
      boxShadow: o.ifFeature(
        "encore",
        `inset 1px 1px 0px 1px ${d.alpha(c.surface.neutral.xxStrong, 0.05)}`,
        j
      ),
      boxSizing: "border-box",
      display: "flex",
      height: v(s),
      justifyContent: "center",
      position: "relative",
      transition: "border-radius 200ms ease",
      width: v(s),
      ".MuiCheckbox-root.Mui-disabled &": {
        border: `1px solid ${o.ifFeature("encore", r.gray[200], r.gray[300])}`,
        boxShadow: "none"
      },
      [`.${i.warning} &, .${i.error} &, .${i.root}:focus-within &`]: {
        borderColor: "currentColor"
      },
      [`.${i.root}:focus-within &`]: {
        border: `1px solid ${o.ifFeature("encore", r.gray[400])}`,
        boxShadow: o.ifFeature(
          "encore",
          `${y}, 0px 0px 0px 3px ${c.surface.primary.weak}`,
          `${j}, 0 0 0 2px ${d.alpha(r.primary.lighter, 0.35)}`
        )
      },
      [`.${i.warning}:focus-within &`]: {
        border: o.ifFeature("encore", `1px solid ${r.warning.main}`),
        boxShadow: o.ifFeature(
          "encore",
          `${y}, 0px 0px 0px 3px ${c.surface.warning.weak}`,
          `${j}, 0 0 0 2px ${d.alpha(r.warning.light, 0.15)}`
        )
      },
      [`.${i.error}:focus-within &`]: {
        border: o.ifFeature("encore", `1px solid ${r.error.main}`),
        boxShadow: o.ifFeature(
          "encore",
          `${y}, 0px 0px 0px 3px ${c.surface.error.weak}`,
          `${j}, 0 0 0 2px ${d.alpha(r.error.light, 0.15)}`
        )
      }
    },
    warning: {
      color: e.palette.warning.main
    }
  };
}), gr = me(
  ({
    apiRef: e,
    ariaDescribedby: a,
    biId: i,
    checked: c,
    classes: r = {},
    className: d,
    containerRef: p,
    disabled: u = !1,
    errorMessage: y,
    form: F,
    id: b,
    indeterminate: x = !1,
    inputProps: l,
    label: s,
    name: w,
    note: h,
    onBlur: $,
    onChange: I,
    required: S = !1,
    size: k = "medium",
    status: f = "default",
    tabIndex: oe,
    warningMessage: te,
    value: M
  }, ae) => {
    u = f === "pending" || u;
    const E = ue(null);
    pe(
      e,
      () => ({
        focus: () => {
          var C;
          (C = E.current) == null || C.focus();
        }
      }),
      [E]
    );
    const ne = {
      checked: c,
      disabled: u,
      indeterminate: x,
      required: S,
      size: o.ifFeature("encore", We[k], k),
      status: f
    }, { classes: m } = Ae(ne), D = xe(() => X.uniqueId("status-message"), []), B = f === "error" ? y : te, U = ce(), A = o.ifFeature("encore", Ue(f), De(f, k));
    return /* @__PURE__ */ t.jsxs(
      "div",
      {
        className: g(m.root, d, r.root, {
          [m.warning]: f === "warning",
          [m.error]: f === "error"
        }),
        "data-fabric-component": "Checkbox",
        ref: p,
        children: [
          s ? /* @__PURE__ */ t.jsxs(n.Fragment, { children: [
            /* @__PURE__ */ t.jsxs("div", { className: g(m.labelContainer, r.labelContainer), children: [
              /* @__PURE__ */ t.jsx(
                we,
                {
                  classes: {
                    label: g(m.label, r.label),
                    root: g(m.labelRoot, r.labelRoot)
                  },
                  control: U,
                  label: /* @__PURE__ */ t.jsxs(n.Fragment, { children: [
                    A && /* @__PURE__ */ t.jsx("div", { className: g(m.statusIcon, r.statusIcon), children: A }),
                    /* @__PURE__ */ t.jsxs("div", { className: g(m.labelContent, r.labelContent), children: [
                      s,
                      o.ifFeature("encore", S && "*")
                    ] })
                  ] }),
                  value: M
                }
              ),
              o.ifFeature(
                "encore",
                null,
                S && /* @__PURE__ */ t.jsx("div", { className: g(m.asterisk, r.asterisk), children: "*" })
              )
            ] }),
            o.ifFeature(
              "encore",
              h && /* @__PURE__ */ t.jsx("div", { className: m.note, children: /* @__PURE__ */ t.jsx(fe, { children: h }) }),
              se()
            )
          ] }) : U,
          B && (f === "error" || f === "warning") && /* @__PURE__ */ t.jsx(ge, { marginTop: 1, children: /* @__PURE__ */ t.jsx(he, { id: D, message: B, status: f }) })
        ]
      }
    );
    function ie(C) {
      const { checked: le, name: de } = C.target;
      I(
        {
          checked: le,
          name: de,
          value: M
        },
        C
      );
    }
    function ce() {
      const C = {
        "data-bi-id": Ge(i, w, M),
        ...l,
        "aria-describedby": ke(
          B ? D : "",
          a,
          l == null ? void 0 : l["aria-describedby"]
        ),
        "aria-invalid": f === "error"
      };
      return /* @__PURE__ */ t.jsx(
        Pe,
        {
          checked: c,
          checkedIcon: z(),
          disabled: u,
          form: F,
          icon: z(),
          id: b,
          indeterminate: x,
          indeterminateIcon: z(),
          inputProps: { ...C, ...l },
          inputRef: Ce(ae, E),
          name: w,
          onBlur: $,
          onChange: ie,
          required: S,
          tabIndex: oe,
          value: M
        }
      );
    }
    function z() {
      return /* @__PURE__ */ t.jsxs("div", { className: g(m.unselectedBox, r.unselectedBox), children: [
        /* @__PURE__ */ t.jsx("div", { className: g(m.selectedBox, r.selectedBox) }),
        /* @__PURE__ */ t.jsx("div", { className: g(m.selectedIcon, r.selectedIcon), children: x ? o.ifFeature("encore", /* @__PURE__ */ t.jsx(R, { name: "dash-solid", size: 16 }), /* @__PURE__ */ t.jsx(ee, { "aria-hidden": "true" })) : o.ifFeature("encore", /* @__PURE__ */ t.jsx(R, { name: "check-solid", size: 16 }), /* @__PURE__ */ t.jsx(Y, { "aria-hidden": "true" })) })
      ] });
    }
    function se() {
      if (h) {
        const C = X.isString(h) ? {} : { component: "div" };
        return /* @__PURE__ */ t.jsx(Le, { className: g(m.note, r.note), ...C, variant: "body1", children: h });
      }
    }
  }
);
export {
  gr as C,
  P as I
};
//# sourceMappingURL=checkbox-DiWnVoeQ.mjs.map
